export default class Camera {
  // 设置摄像机
  static setCamera(jsonData) {
    appInstance.uniCall(
      'setCamera', jsonData, res => {
        console.log('设置相机视角', jsonData, res);
      }
    )
  }
  static rotateCamera(flag) {
    window.appInstance.uniCall('rotateCamera', {
      enabled: flag,
      duration: 240,
      direction: 'clockwise',
      interruptable: false,
    })
  }
  // 设置相机视角限制参数
  static restrictCamera(jsonData, flag = true) {
    if (typeof jsonData == 'boolean' || !jsonData) {
      return
    }
    appInstance.uniCall('restrictCamera', jsonData, (result) => {
      console.log('视角限制参数', flag, result)
      this.setCameraRestrictionState(flag)
    })
  }
  // 设置相机视角限制状态
  static setCameraRestrictionState(flag = true) {
    appInstance.uniCall(
      'setCameraRestrictionState',
      {
        state: flag ? 'restricted' : 'free',
      },
      (result) => {
        console.log('视角限制状态', flag, result)
      }
    )
  }
  // 路径漫游相机
  static pathingCamera(id, speed) {
    let jsonData = {
      pathId: id,
      loopMode: "none",
      reverse: false,
      distance: 10,
      pitch: 2,
      speed: speed || 5
    }
    window.appInstance.uniCall('pathingCamera', jsonData, res => {
      console.log('开启路径漫游', jsonData, res);
    })
  }
  // 设置路径漫游状态
  static setCameraPathingState(state) {
    let jsonData = {
      state: state
    }
    window.appInstance.uniCall('setCameraPathingState', jsonData, res => {
      console.log('设置路径移动镜头状态', jsonData, res);
    })
  }
  // 聚焦覆盖物
  static focusById(params) {
    let jsonData = {
      id: params.id,
      overlayType: params.overlayType,
      distance: params.distance || 50
    }
    appInstance.uniCall('focusById', jsonData, res => {
      console.log('focusById', jsonData, res)
    })
  }
  // 聚焦 图层子覆盖物
  static focusByLayer(params) {
    let jsonData = {
      id: params.id,
      idLayer: params.idLayer,
      layerType: params.layerType,
      distance: params.distance || 100
    }
    appInstance.uniCall('focusByLayer', jsonData, res => {
      console.log('focusByLayer', jsonData, res)
    })
  }
  // 聚焦模型
  static focusModel(params) {
    let jsonData = {
      id: params.id,
      modelType: params.modelType,
      distance: params.distance
    }
    appInstance.uniCall('focusModel', jsonData, res => {
      console.log('focusModel', jsonData, res)
    })
  }
  // 聚焦 建筑
  static focusBuilding(params) {
    let jsonData = {
      buildingId: params.buildingId,
      distance: params.distance || 100
    }
    appInstance.uniCall('focusBuilding', jsonData, res => {
      console.log('focusBuilding', jsonData, res)
    })
  }
  // 聚焦 楼层
  static focusFloor(params) {
    let jsonData = {
      buildingId: params.buildingId,
      floor: params.floor,
      distance: params.distance || 100
    }

    appInstance.uniCall('focusFloor', jsonData, res => {
      console.log('focusFloor', jsonData, res)
    })
  }
  //
}